import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { COOKIE_KEY } from './Api';

export default function CookieConsentBanner({ onConsentChange }) {
  const [showBanner, setShowBanner] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [analytics, setAnalytics] = useState(true);
  
  const { i18n } = useTranslation();
  const lang = i18n.language;

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_KEY);
    if (!consent) setShowBanner(true);
  }, []);

  const saveConsent = (settings) => {
    localStorage.setItem(COOKIE_KEY, JSON.stringify(settings));
    setShowBanner(false);
    setShowModal(false);
    if (typeof onConsentChange === 'function') {
      onConsentChange(settings.analytics);
    }
  };

  const handleAcceptAll = () => {
    saveConsent({ necessary: true, analytics: true });
  };

  const handleDeclineAll = () => {
    saveConsent({ necessary: true, analytics: false });
  };

  const handleCustomize = () => {
    setShowModal(true);
  };

  if (!showBanner) return null;

  return (
    <>
      {/* Banner */}
      <div className="fixed bottom-4 left-4 right-4 2xl:left-1/2 2xl:right-auto 2xl:transform 2xl:-translate-x-1/2 bg-white text-gray-800 px-4 sm:px-6 py-4 shadow-xl rounded-xl flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 z-50 border border-gray-200">
        <div>
          <p className="text-base font-semibold">We value your privacy</p>
          <p className="text-sm">
          We use cookies to improve your experience and gather analytics data about how visitors use the website. Read more in our{' '}
            <a href={`/${lang}/privacy-policy`} className="underline text-blue-600 hover:text-blue-800">Privacy policy</a>.
          </p>
        </div>
        <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4 sm:ml-auto w-full sm:w-auto">
          <button onClick={handleDeclineAll} className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-100 transition">Decline</button>
          <button onClick={handleAcceptAll} className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition">Accept</button>
          <button onClick={handleCustomize} className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-100 transition">Customize</button>
        </div>
      </div>

      {/* Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-2xl shadow-lg w-full max-w-md transition-transform duration-300 transform scale-100">
            <h2 className="text-xl font-semibold mb-4">Manage your preferences</h2>
            <div className="mb-6 space-y-5">
              <div>
                <label className="flex items-center text-sm mb-1">
                  <input type="checkbox" checked disabled className="mr-2" />
                  <span className="text-gray-800 font-medium">Necessary</span>
                </label>
                <p className="text-xs text-gray-600">
                  Necessary cookies are required to enable the basic features of this site. These cookies do not store any personally identifiable data.
                </p>
              </div>
              <div>
                <label className="flex items-center text-sm mb-1">
                  <input
                    type="checkbox"
                    checked={analytics}
                    onChange={(e) => setAnalytics(e.target.checked)}
                    className="mr-2"
                  />
                  <span className="text-gray-800 font-medium">Analytics</span>
                </label>
                <p className="text-xs text-gray-600">
                  Analytical cookies are used to understand how visitors interact with the website. These cookies help provide information on metrics such as the number of visitors.
                </p>
              </div>
            </div>
            <div className="flex justify-end gap-2">
              <button onClick={() => setShowModal(false)} className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-100 transition">Cancel</button>
              <button onClick={() => saveConsent({ necessary: true, analytics })} className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition">Save preferences</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
